import { SortDirection } from '@angular/material/sort';

import { DemandStatus } from '../../../../Enums/demand-status.enum';
import { Platform } from '../../../../Enums/platform.enum';
import { AllDemandsFilterCriteria } from '../Interfaces/all-demands-filters.interface';
import { ReportSubjectTab } from '../Types/report-subject-tab.type';

export const ALL_DEMANDS_DEFAULT_PAGE_SIZE = 10;
export const ALL_DEMANDS_DEFAULT_PAGE = 0;

export const ALL_DEMANDS_DEFAULT_ORDER_BY = 'created_at';
export const ALL_DEMANDS_DEFAULT_ORDER: SortDirection = 'desc';
export const ALL_DEMANDS_ORDER_BY_VALUES: ReadonlyArray<string> = [
  'subject',
  'reference',
  'requester',
  'status',
  'progress',
  'created_at',
  'updated_at',
];
export const ALL_DEMANDS_ORDER_VALUES: ReadonlyArray<SortDirection> = ['asc', 'desc'];

export const ALL_DEMANDS_STATUS_VALUES: ReadonlyArray<DemandStatus> = [
  DemandStatus.Pending,
  DemandStatus.Ongoing,
  DemandStatus.Approved,
  DemandStatus.AutoApproved,
  DemandStatus.Rejected,
  DemandStatus.Canceled,
  DemandStatus.Failed,
  DemandStatus.ClosedCreatorRemoved,
];

export const ALL_DEMANDS_PLATFORM_VALUES: ReadonlyArray<Platform> = [
  Platform.Windows,
  Platform.Macos,
];

export const ALL_DEMANDS_SUBJECT_TABS: ReadonlyArray<ReportSubjectTab> = ['application', 'group'];

export const ALL_DEMANDS_DEVICE_MAX_LENGTH = 255;

export const ALL_DEMANDS_DEFAULT_CRITERIA: Readonly<AllDemandsFilterCriteria> = {
  statuses: [],
  search: '',
  requestedFrom: null,
  requestedTo: null,
  updatedFrom: null,
  updatedTo: null,
  platform: null,
  device: '',
  requesterId: null,
  subjectId: null,
  approverId: null,
  moderatorId: null,
  decidedById: null,
};
